import { getPrasedToken } from "./utils"
import { setNotification } from "@/api/notification"
export const isRTALogin = () => {
  const token = getPrasedToken()
  if (!token) return false
  if (token.logChannel === 1 || token.logChannel === 2) {
    return true
  }
  return false
}

const PasswordRegex = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/

export const validatePassword = password => {
  return PasswordRegex.test(password)
}

export const validatePhoneNumber = phoneNumber => {
  const regexSingapore = /^\+65\s\d{8}$/
  const regexMalaysia = /^\+60\s\d{1,2}-*[0-9]{7,8}$/
  return regexSingapore.test(phoneNumber) || regexMalaysia.test(phoneNumber)
}
